import React, { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import banner from "../../assets/images/trustworthy-about-banner.jpg";

import { getCategoryList } from "../server/api";

function AllServices() {

  const [category, setCategory] = useState([]);

  const fetchCategory = async () => {
    try {
      const res = await getCategoryList();
      if (res.status == true) {
        const category = res.data;
        console.warn("ssssssss", category);
        setCategory(category);
      }
      else {
        alert("Hello");
      }

    } catch (error) {
      console.error("category API Error:", error);
    }
  };

  useEffect(() => {
    fetchCategory();
  }, []);
  return (
    <>
      <section className="inner-banner">
        <img src={banner} alt="About Us Banner" className="inner-banner-img" />

        <div className="inner-banner-content">
          <div className="container">
            <div className="inner-banner-content-in">
              <h1>All Services</h1>

              <p>
                Best Home Servicing Company for your Household items Servicing
                or Repairing
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="services py-5">
        <div className="container py-5">
          {/* Heading */}
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center mb-5">
              <span className="works-subtitle">Service Categories </span>
              <h2 className="display-5 fw-bold mb-4">
                Service Platform Overview
              </h2>
              <p className="lead">
                Expand your reach and get discovered by trusted housing
                societies and residents with Sevasati’s service network.
              </p>
            </div>
          </div>

          {/* Categories */}
          <Row className="g-4">
            {category.map((item, index) => (
              <div key={item._id || index} className="col-md-6 col-lg-3">
                <div className="card h-100 text-center hover-card">
                  <div className="card-body">

                    {/* Image */}
                    <div className="icon-wrapper mb-3">
                      <img
                        src={`${process.env.REACT_APP_URL}${item.image}`}
                        alt={item.title}
                        className="img-fluid"
                        style={{ width: "60px", height: "60px" }}
                      />
                    </div>

                    {/* Title */}
                    <h5 className="mb-0">{item.title}</h5>
                  </div>
                </div>
              </div>
            ))}
          </Row>
        </div>
      </section>
    </>
  );
}

export default AllServices;
